/* unplugin-vue-components disabled */import script from "./member-list.vue?vue&type=script&lang=jsx"
export * from "./member-list.vue?vue&type=script&lang=jsx"

import "./member-list.vue?vue&type=style&index=0&id=e2d83644&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2d83644"]])

export default __exports__